import { connect } from 'react-redux';
import { openPanel } from 'services/custom-panels';
import ShowPersonCardCta from './view';

const mapDispatchToProps = dispatch => ({
  onClick: data => dispatch(openPanel(data)),
});

export default connect(null, mapDispatchToProps)(ShowPersonCardCta);
